import React, { useEffect, useState } from "react";

export const CountDown = ({
  meetingTime,
  roomId,
}: {
  meetingTime: string;
  roomId: string;
}) => {
  const [timeLeft, setTimeLeft] = useState(() => calculateTimeLeft(meetingTime));
  const [status, setStatus] = useState("countdown");

  useEffect(() => {
    const timer = setInterval(() => {
      const newTimeLeft = calculateTimeLeft(meetingTime);
      setTimeLeft(newTimeLeft);
      updateStatus(meetingTime);
    }, 1000);

    return () => clearInterval(timer);
  }, [meetingTime]);

  const updateStatus = (meetingTime: string) => {
    const now = new Date();
    const meetingDate = new Date(meetingTime);
    const thirtyMinutesBefore = new Date(meetingDate.getTime() - 30 * 60 * 1000);
    const twoHoursAfter = new Date(meetingDate.getTime() + 2 * 60 * 60 * 1000);

    if (now >= thirtyMinutesBefore && now < twoHoursAfter) {
      setStatus("joinNow");
    } else if (now >= twoHoursAfter) {
      setStatus("completed");
    } else {
      setStatus("countdown");
    }
  };

  if (timeLeft.totalHours > 24) return null;

  if (status === "joinNow") {
    return (
      <button
        className="bg-blue-500 text-white px-4 py-2 rounded-lg"
        onClick={() => {
          window.location.href = `/videocall?room_id=${roomId}`;
        }}
      >
        Join Now
      </button>
    );
  }

  if (status === "completed") {
    return <p>Completed</p>;
  }

  return (
    <div>
      {String(timeLeft.hours).padStart(2, '0')}:
      {String(timeLeft.minutes).padStart(2, '0')}:
      {String(timeLeft.seconds).padStart(2, '0')}
    </div>
  );
};

const calculateTimeLeft = (meetingTime: string) => {
  const meetingDate = new Date(meetingTime);
  const now = new Date();
  const difference = meetingDate.getTime() - now.getTime();

  if (difference <= 0) {
    return { totalHours: 0, hours: 0, minutes: 0, seconds: 0 };
  }

  const totalHours = Math.floor(difference / (1000 * 60 * 60));
  const hours = Math.floor((difference / (1000 * 60 * 60)) % 24);
  const minutes = Math.floor((difference / 1000 / 60) % 60);
  const seconds = Math.floor((difference / 1000) % 60);

  return { totalHours, hours, minutes, seconds };
};